export default "__VITE_ASSET__e2bc6b98__"